import { createApi } from '@reduxjs/toolkit/query/react'
import { NetWork } from '../../../common/apiKey'
import { DELETE, GET, PATCH, POST, PUT } from '../../../common/contants'
import { axiosBaseQuery } from '../../baseQuery'
import { ReponseData2 } from '../../../types'
import { Staff } from '../../../types/staff'
// import { ReponseData } from '../../types'

export const staffApi = createApi({
  reducerPath: 'staffApi',
  baseQuery: axiosBaseQuery,
  tagTypes: ['Staff'], // Đảm bảo tagType là 'Staff'
  endpoints: (builder) => ({
    getListStaff: builder.query({
      query: (params) => ({
        url: NetWork.staff,
        method: GET,
        params: params,
        providesTags: (result: ReponseData2<{ rows: Staff[] }>) => (result ? [{ type: 'Staff', id: 'LIST' }] : []) // Cung cấp tag 'Staff' với id 'LIST'
      })
    }),
    getStaffById: builder.query({
      query: (params: { staffId: number }) => ({
        url: NetWork.staffId(params.staffId),
        method: GET
      })
    }),
    addStaff: builder.mutation({
      query: (data) => ({
        url: NetWork.staff,
        method: POST,
        data: data
      })
    }),
    updateStaff: builder.mutation({
      query: (data) => ({
        url: NetWork.staffId(data.id),
        method: PUT,
        data: data
      })
    }),
    deleteStaff: builder.mutation({
      query: (data: { ids: Array<number | string> }) => ({
        url: NetWork.staff,
        method: DELETE,
        data: data
        // invalidatesTags: [{ type: 'Staff', id: 'LIST' }] // Vô hiệu hóa tag 'Staff' với id 'LIST' để gọi lại getListStaff
      })
    }),
    changeStatusStaff: builder.mutation({
      query: (data: { staffId: number; params: { isActive: boolean } }) => ({
        url: NetWork.staffId(data.staffId),
        method: PATCH,
        params: data.params
      })
    }),
    uploadFileStaff: builder.mutation({
      query: (data) => ({
        url: NetWork.uploadCccdStaff,
        method: POST,
        data: data,
        headers: { 'Content-Type': 'multipart/form-data' }
      })
    }),

    //Start Tạm bỏ
    activeStaff: builder.mutation({
      query: (data: { staffId: number; active: boolean }) => ({
        url: NetWork.accountActive(data.staffId),
        method: PATCH,
        params: { active: data.active }
      })
    }),
    //History
    getListHistoryStaff: builder.query({
      query: (params: { staffId: number }) => ({
        url: NetWork.staffHistoryList(params.staffId),
        method: GET,
        providesTags: (result: ReponseData2<{ rows: Staff[] }>) => (result ? [{ type: 'Staff', id: 'LIST' }] : []) // Cung cấp tag 'Staff' với id 'LIST'
      })
    }),
    getHistoryStaffById: builder.query({
      query: (params: { staffId: number }) => ({
        url: NetWork.staffId(params.staffId),
        method: GET
      })
    }),
    addHistoryStaff: builder.mutation({
      query: (data) => ({
        url: NetWork.staffHistory,
        method: POST,
        data: data
      })
    }),
    updateHistoryStaff: builder.mutation({
      query: (data) => ({
        url: NetWork.staffHistoryId(data.id),
        method: PUT,
        data: data
      })
    }),
    deleteHistoryStaff: builder.mutation({
      query: (data: { ids: Array<number> }) => ({
        url: NetWork.staffHistory,
        method: DELETE,
        data: data
        // invalidatesTags: [{ type: 'Staff', id: 'LIST' }] // Vô hiệu hóa tag 'Staff' với id 'LIST' để gọi lại getListStaff
      })
    }),
    //Salary
    getListSalaryStaff: builder.query({
      query: (params: { staffId: number }) => ({
        url: NetWork.staffSalaryList(params.staffId),
        method: GET
      })
    }),
    getSalaryStaffById: builder.query({
      query: (params: { staffId: number }) => ({
        url: NetWork.staffId(params.staffId),
        method: GET
      })
    }),
    addSalaryStaff: builder.mutation({
      query: (data) => ({
        url: NetWork.staffSalary,
        method: POST,
        data: data
      })
    }),
    updateSalaryStaff: builder.mutation({
      query: (data) => ({
        url: NetWork.staffSalaryId(data.id),
        method: PUT,
        data: data
      })
    }),
    deleteSalaryStaff: builder.mutation({
      query: (data: { ids: Array<number> }) => ({
        url: NetWork.staffSalary,
        method: DELETE,
        data: data
        // invalidatesTags: [{ type: 'Staff', id: 'LIST' }] // Vô hiệu hóa tag 'Staff' với id 'LIST' để gọi lại getListStaff
      })
    })
    //End Tạm bỏ
  })
})

// Export hooks for usage in functional components
export const {
  useGetListStaffQuery,
  useDeleteStaffMutation,
  useAddStaffMutation,
  useGetStaffByIdQuery,
  useUpdateStaffMutation,
  useChangeStatusStaffMutation,
  useUploadFileStaffMutation,
  //Bỏ
  useActiveStaffMutation,
  //History
  useAddHistoryStaffMutation,
  useDeleteHistoryStaffMutation,
  useGetHistoryStaffByIdQuery,
  useGetListHistoryStaffQuery,
  useUpdateHistoryStaffMutation,
  //Salary
  useAddSalaryStaffMutation,
  useDeleteSalaryStaffMutation,
  useGetSalaryStaffByIdQuery,
  useGetListSalaryStaffQuery,
  useUpdateSalaryStaffMutation
} = staffApi
